import React, { ReactNode } from 'react'
import { Spinner } from 'react-bootstrap'

const LoadingFailed = (props: { text: string, additionalInfo?: string, children?: ReactNode }) => {
  const { text, additionalInfo, children } = props

  return (
    <div
      className='d-flex flex-column align-items-center mt-3'
    >
      <h1 className='text-danger'>&times;</h1>
      <h4>{text}</h4>
      <p className="text-muted small">{additionalInfo}</p>
      {children}
    </div>
  )
}

export default LoadingFailed
